// extracted by mini-css-extract-plugin
export default {"container":"AdsListAmination_container__TwC6H"};